export default __webpack_public_path__ + "static/media/vscode.76aff78a.png";